export const APP_VERSION = '1.0.21';
export const API_BASE_URL = process.env.REACT_APP_APIURL;
export const ENABLE_REDUX_LOGGER = false;
export const WP_BLOG_URL = process.env.REACT_APP_WP_BLOG_URL;
export const WP_FORUM_URL = process.env.REACT_APP_WP_FORUM_URL;
export default {};
